<template>
  <div class="content-with-image" :style="{ margin: margin }">
    <b-row align-v="center" class="justify-items-sm-center">
      <b-col class="image-column" lg="6" md="12" cols="12" :class="['order-md-' + imageOrder, 'order-' + imageOrderSm]">
        <div class="image-column__wrapper" :style="{ margin: imageMargin }">
          <slot name="imgText"/>
          <img :src="imageSrc" alt="" :style="{'max-width': imgWidth}">
          <slot name="imgTextBot"/>
        </div>
      </b-col>
      <b-col class="text-column" lg="6" md="12" cols="12">
        <slot/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'ContentWithImage',
  props: {
    src: {
      type: String,
      required: true
    },
    imgWidth: {
      type: String,
      required: false,
      default: '100%'
    },
    ext: {
      type: String,
      default: 'png'
    },
    margin: {
      type: String,
      default: '150px 0'
    },
    imageOrder: {
      type: String,
      default: '1'
    },
    imageOrderSm: {
      type: String,
      default: '1'
    },
    imageMargin: {
      type: String,
      default: 'auto'
    }
  },
  computed: {
    imageSrc: app => require(`@/assets/${app.src}.${app.ext}`)
  }
}
</script>

<style lang="sass" scoped>
.slick-prev
  +media-breakpoint-down(md)
    left: -25px
.slick-next
  +media-breakpoint-down(md)
    right: -25px
.order-md-2
  visibility: hidden
.image-column
  &__wrapper
    +media-breakpoint-down(lg)
      margin: auto!important

  img
    max-width: 100%
    width: 100%

  +media-breakpoint-down(sm)
    &.order-2
      visibility: hidden
    &.order-0
      margin-bottom: 50px
    &.order-1
      margin-top: 50px
</style>



// WEBPACK FOOTER //
// src/components/ui/ContentWithImageMd.vue